import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { RootState } from 'redux/rootReducer';

import { loadCountries } from 'redux/reducers/countries';
import SearchableDropdown from 'components/base/Dropdown/SearchableDropdown';
import {
  IUserSettingsState,
  loadOrInitUserSettings,
  shouldLoadUserSettings,
} from 'redux/reducers/userSettings';
import { saveUserRole } from 'redux/reducers/user/updateUserRole';

import { ListItem } from '../Location';

import getRoles from './getRoles';

const ConfirmRoleWrapper = styled('div')`
  position: relative;
`;
const DropdownWrapper = styled('div')`
  max-width: fit-content;
`;

interface IDropdownRole {
  label: string;
  value: string;
}

const Role: React.FC<any> = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const roles = getRoles();

  const [selectedRole, setSelectedRole] = useState({
    label: 'Select role',
    value: '',
  });

  const userSettings = useSelector(
    (state: RootState): IUserSettingsState => state.userSettings
  );

  const userRoleFromSettings = userSettings?.data?.userRole;

  useEffect(() => {
    if (!selectedRole.value && userRoleFromSettings) {
      const roleFromSettings = roles.find(
        (role: any) => role.value === userRoleFromSettings
      );
      setSelectedRole(
        roleFromSettings || {
          label: 'Select role',
          value: '',
        }
      );
    }
  }, [userRoleFromSettings]);

  useEffect(() => {
    dispatch(loadCountries());

    if (dispatch(shouldLoadUserSettings())) {
      dispatch(loadOrInitUserSettings());
    }
  }, [dispatch]);

  const saveRole = (newRole: any): void => {
    const userRoleId = newRole?.value;
    if (userRoleId) {
      dispatch(saveUserRole(userRoleId));
    }
  };

  useImperativeHandle(ref, () => ({
    externalSave(): void {
      saveRole(selectedRole);
    },
  }));

  const onChange = (newRole: IDropdownRole): void => {
    setSelectedRole(newRole);
    if (!ref) {
      saveRole(newRole);
    }
  };

  return roles ? (
    <ConfirmRoleWrapper>
      <DropdownWrapper>
        <SearchableDropdown
          items={roles}
          selectedItem={selectedRole}
          onChange={onChange}
          Item={ListItem}
          disabled={false}
          isActiveGreen={false}
          isRoundedDropdown="all"
        />
      </DropdownWrapper>
    </ConfirmRoleWrapper>
  ) : null;
});

export default Role;
